<template>
  <div class="shop-create">
    <!-- 顶部操作栏 -->
    <div class="action-bar">
      <div class="left-actions">
        <el-button icon="el-icon-back" size="medium" plain @click="goBack">返回列表</el-button>
      </div>
      <div class="right-actions">
        <el-button type="primary" icon="el-icon-check" size="medium" @click="submitForm" :loading="submitting">创建商品</el-button>
      </div>
    </div>

    <!-- 主要内容区 -->
    <div class="main-content">
      <div class="content-grid">
        <!-- 左侧内容列 -->
        <div class="left-column">
          <!-- 标题卡片 -->
          <el-card class="title-card">
            <div class="card-header">
              <span>商品标题</span>
            </div>
            <div class="title-grid">
              <div class="title-cn">
                <div class="title-label">中文标题</div>
                <el-input v-model="shopForm.title_cn" placeholder="请输入中文标题"></el-input>
              </div>
              <div class="title-ug">
                <div class="title-label">ئۇيغۇرچە تېمىسى</div>
                <el-input v-model="shopForm.title_ug" placeholder="ئۇيغۇرچە تېمىسىنى كىرگۈزۈڭ"></el-input>
              </div>
            </div>
          </el-card>

          <!-- 基本信息卡片 -->
          <el-card class="info-card">
            <div class="card-header">
              <span>基本信息</span>
            </div>
            <div class="info-grid">
              <div class="info-column">
                <div class="info-item">
                  <div class="info-label">商品状态</div>
                  <el-select v-model="shopForm.status" placeholder="请选择商品状态" style="width: 100%">
                    <el-option
                      v-for="(item, id) in statusMap"
                      :key="id"
                      :label="item.text"
                      :value="Number(id)">
                    </el-option>
                  </el-select>
                </div>

                <div class="info-item">
                  <div class="info-label">商品价格</div>
                  <el-input-number 
                    v-model="shopForm.price" 
                    :min="0" 
                    :precision="2" 
                    style="width: 100%"
                    :controls-position="'right'"
                    class="price-input">
                  </el-input-number>
                </div>
              </div>

              <div class="info-column">
                <div class="info-item">
                  <div class="info-label">是否需要地址</div>
                  <el-select v-model="shopForm.need_addr" placeholder="请选择是否需要地址" style="width: 100%">
                    <el-option :value="true" label="需要"></el-option>
                    <el-option :value="false" label="不需要"></el-option>
                  </el-select>
                </div>

                <div class="info-item">
                  <div class="info-label">库存数量</div>
                  <el-input-number 
                    v-model="shopForm.stock" 
                    :min="0" 
                    :precision="0" 
                    style="width: 100%"
                    :controls-position="'right'"
                    class="stock-input">
                  </el-input-number>
                </div>
              </div>
            </div>
          </el-card>

          <!-- 标签和特性卡片 -->
          <el-card class="tags-card">
            <div class="card-header">
              <span>标签和特性</span>
            </div>
            <div class="tags-grid">
              <div class="tags-row">
                <div class="tags-item">
                  <div class="tags-label">标签颜色</div>
                  <el-select v-model="shopForm.tag_color" placeholder="请选择标签颜色" style="width: 100%">
                    <el-option label="蓝色" value="blue"></el-option>
                    <el-option label="红色" value="red"></el-option>
                  </el-select>
                </div>

                <div class="tags-item">
                  <div class="tags-label">中文标签</div>
                  <el-input v-model="shopForm.tag_cn" placeholder="请输入中文标签"></el-input>
                </div>

                <div class="tags-item">
                  <div class="tags-label">维文标签</div>
                  <el-input v-model="shopForm.tag_ug" placeholder="ئۇيغۇرچە بەلگىنى كىرگۈزۈڭ"></el-input>
                </div>
              </div>

              <div class="tags-row">
                <div class="tags-item">
                  <div class="tags-label">中文特性</div>
                  <el-input v-model="shopForm.feature_cn" placeholder="请输入中文特性"></el-input>
                </div>

                <div class="tags-item">
                  <div class="tags-label">维文特性</div>
                  <el-input v-model="shopForm.feature_ug" placeholder="ئۇيغۇرچە ئالاھىدىلىكىنى كىرگۈزۈڭ"></el-input>
                </div>
              </div>

              <div class="tags-row">
                <div class="tags-item">
                  <div class="tags-label">中文促销词</div>
                  <el-input v-model="shopForm.label_cn" placeholder="请输入中文促销词"></el-input>
                </div>

                <div class="tags-item">
                  <div class="tags-label">维文促销词</div>
                  <el-input v-model="shopForm.label_ug" placeholder="ئۇيغۇرچە سېتىش سۆزىنى كىرگۈزۈڭ"></el-input>
                </div>
              </div>
            </div>
          </el-card>

          <!-- 商品描述卡片 -->
          <el-card class="desc-card">
            <div class="card-header">
              <span>商品描述</span>
            </div>
            <div class="desc-grid">
              <div class="desc-cn">
                <div class="desc-label">中文描述</div>
                <el-input 
                  type="textarea" 
                  v-model="shopForm.desc_cn" 
                  placeholder="请输入中文描述" 
                  :rows="6"
                  :maxlength="2000"
                  show-word-limit>
                </el-input>
              </div>
              <div class="desc-ug">
                <div class="desc-label">ئۇيغۇرچە تونۇشتۇرۇلىشى</div>
                <el-input 
                  type="textarea" 
                  v-model="shopForm.desc_ug" 
                  placeholder="ئۇيغۇرچە تونۇشتۇرۇلىشىنى كىرگۈزۈڭ" 
                  :rows="6"
                  :maxlength="8000"
                  show-word-limit
                  class="ug-input">
                </el-input>
              </div>
            </div>
          </el-card>
        </div>

        <!-- 右侧内容列 -->
        <div class="right-column">
          <!-- 分类卡片 -->
          <el-card class="category-card">
            <div class="card-header">
              <span>商品分类</span>
            </div>
            <div class="category-content">
              <div class="category-item">
                <div class="category-label">分类</div>
                <el-select 
                  v-model="shopForm.category_id" 
                  placeholder="请选择商品分类"
                  style="width: 100%">
                  <el-option
                    v-for="item in categoryList"
                    :key="item.category_id"
                    :label="item.name_cn"
                    :value="item.category_id">
                  </el-option>
                </el-select>
              </div>
            </div>
          </el-card>

          <!-- 商品图片卡片 -->
          <el-card class="images-card">
            <div class="card-header">
              <span>商品图片</span>
            </div>
            <div class="images-wrapper">
              <!-- 封面图 -->
              <div class="image-section">
                <div class="cover-grid">
                  <div class="cover-item">
                    <div class="label-cn">中文封面图</div>
                    <div class="image-container cover-shape">
                      <template v-if="shopForm.cover_cn">
                        <el-image 
                          :src="getImageUrl(shopForm.cover_cn)"
                          :preview-src-list="[getImageUrl(shopForm.cover_cn)]">
                        </el-image>
                        <div class="image-actions">
                          <el-button 
                            type="danger" 
                            icon="el-icon-delete" 
                            class="delete-button"
                            circle 
                            size="mini" 
                            @click="removeImage('cover_cn')">
                          </el-button>
                        </div>
                      </template>
                      <template v-else>
                        <div class="upload-box cover-shape">
                          <el-upload
                            class="image-uploader"
                            :action="getUploadUrl('cover_cn')"
                            :headers="getHeaders()"
                            :show-file-list="false"
                            :on-success="(res) => uploaded(res, 'cover_cn')"
                            :on-error="uploadError"
                            :before-upload="beforeUpload">
                            <i class="el-icon-plus"></i>
                            <div class="upload-text">上传封面图</div>
                          </el-upload>
                        </div>
                      </template>
                    </div>
                  </div>

                  <div class="cover-item">
                    <div class="label-ug">ئۇيغۇرچە مۇقاۋا</div>
                    <div class="image-container cover-shape">
                      <template v-if="shopForm.cover_ug">
                        <el-image 
                          :src="getImageUrl(shopForm.cover_ug)"
                          :preview-src-list="[getImageUrl(shopForm.cover_ug)]">
                        </el-image>
                        <div class="image-actions">
                          <el-button 
                            type="danger" 
                            icon="el-icon-delete" 
                            class="delete-button"
                            circle 
                            size="mini" 
                            @click="removeImage('cover_ug')">
                          </el-button>
                        </div>
                      </template>
                      <template v-else>
                        <div class="upload-box cover-shape">
                          <el-upload
                            class="image-uploader"
                            :action="getUploadUrl('cover_ug')"
                            :headers="getHeaders()"
                            :show-file-list="false"
                            :on-success="(res) => uploaded(res, 'cover_ug')"
                            :on-error="uploadError"
                            :before-upload="beforeUpload">
                            <i class="el-icon-plus"></i>
                            <div class="upload-text">مۇقاۋىنى چىقىرىڭ</div>
                          </el-upload>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 轮播图 -->
              <div class="image-section">
                <div class="carousel-grid">
                  <div class="carousel-column">
                    <div class="label-cn">中文轮播图</div>
                    <div class="image-list">
                      <draggable 
                        class="image-list"
                        v-model="shopForm.swipers_cn">
                        <div v-for="(url, index) in shopForm.swipers_cn" 
                             :key="index" 
                             class="image-item carousel-shape">
                          <el-image 
                            :src="getImageUrl(url)"
                            :preview-src-list="shopForm.swipers_cn.map(img => getImageUrl(img))">
                          </el-image>
                          <div class="image-actions">
                            <el-button 
                              type="danger" 
                              icon="el-icon-delete" 
                              class="delete-button"
                              circle 
                              size="mini"
                              @click="removeImage('swipers_cn', index)">
                            </el-button>
                          </div>
                        </div>
                      </draggable>
                      <div class="upload-box carousel-shape">
                        <el-upload
                          class="image-uploader"
                          :action="getUploadUrl('swipers_cn')"
                          :headers="getHeaders()"
                          :show-file-list="false"
                          :on-success="(res) => uploaded(res, 'swipers_cn')"
                          :on-error="uploadError"
                          :before-upload="beforeUpload">
                          <i class="el-icon-plus"></i>
                          <div class="upload-text">上传轮播图</div>
                        </el-upload>
                      </div>
                    </div>
                  </div>

                  <div class="carousel-column">
                    <div class="label-ug">ئۇيغۇرچە ئايلانما تەگلىكلەر</div>
                    <div class="image-list">
                      <draggable 
                        class="image-list"
                        v-model="shopForm.swipers_ug">
                        <div v-for="(url, index) in shopForm.swipers_ug" 
                             :key="index" 
                             class="image-item carousel-shape">
                          <el-image 
                            :src="getImageUrl(url)"
                            :preview-src-list="shopForm.swipers_ug.map(img => getImageUrl(img))">
                          </el-image>
                          <div class="image-actions">
                            <el-button 
                              type="danger" 
                              icon="el-icon-delete" 
                              class="delete-button"
                              circle 
                              size="mini"
                              @click="removeImage('swipers_ug', index)">
                            </el-button>
                          </div>
                        </div>
                      </draggable>
                      <div class="upload-box carousel-shape">
                        <el-upload
                          class="image-uploader"
                          :action="getUploadUrl('swipers_ug')"
                          :headers="getHeaders()"
                          :show-file-list="false"
                          :on-success="(res) => uploaded(res, 'swipers_ug')"
                          :on-error="uploadError"
                          :before-upload="beforeUpload">
                          <i class="el-icon-plus"></i>
                          <div class="upload-text">تەگلىكلەرنى چىقىرىڭ</div>
                        </el-upload>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 详情图 -->
              <div class="image-section">
                <div class="poster-grid">
                  <div class="poster-column">
                    <div class="label-cn">中文详情图</div>
                    <div class="image-list">
                      <draggable 
                        class="image-list"
                        v-model="shopForm.posters_cn">
                        <div v-for="(url, index) in shopForm.posters_cn" 
                             :key="index" 
                             class="image-item poster-shape">
                          <el-image 
                            :src="getImageUrl(url)"
                            :preview-src-list="shopForm.posters_cn.map(img => getImageUrl(img))">
                          </el-image>
                          <div class="image-actions">
                            <el-button 
                              type="danger" 
                              icon="el-icon-delete" 
                              class="delete-button"
                              circle 
                              size="mini"
                              @click="removeImage('posters_cn', index)">
                            </el-button>
                          </div>
                        </div>
                      </draggable>
                      <div class="upload-box poster-shape">
                        <el-upload
                          class="image-uploader"
                          :action="getUploadUrl('posters_cn')"
                          :headers="getHeaders()"
                          :show-file-list="false"
                          :on-success="(res) => uploaded(res, 'posters_cn')"
                          :on-error="uploadError"
                          :before-upload="beforeUpload">
                          <i class="el-icon-plus"></i>
                          <div class="upload-text">上传详情图</div>
                        </el-upload>
                      </div>
                    </div>
                  </div>

                  <div class="poster-column">
                    <div class="label-ug">ئۇيغۇرچە مەزمۇن رەسىملىرى</div>
                    <div class="image-list">
                      <draggable 
                        class="image-list"
                        v-model="shopForm.posters_ug">
                        <div v-for="(url, index) in shopForm.posters_ug" 
                             :key="index" 
                             class="image-item poster-shape">
                          <el-image 
                            :src="getImageUrl(url)"
                            :preview-src-list="shopForm.posters_ug.map(img => getImageUrl(img))">
                          </el-image>
                          <div class="image-actions">
                            <el-button 
                              type="danger" 
                              icon="el-icon-delete" 
                              class="delete-button"
                              circle 
                              size="mini"
                              @click="removeImage('posters_ug', index)">
                            </el-button>
                          </div>
                        </div>
                      </draggable>
                      <div class="upload-box poster-shape">
                        <el-upload
                          class="image-uploader"
                          :action="getUploadUrl('posters_ug')"
                          :headers="getHeaders()"
                          :show-file-list="false"
                          :on-success="(res) => uploaded(res, 'posters_ug')"
                          :on-error="uploadError"
                          :before-upload="beforeUpload">
                          <i class="el-icon-plus"></i>
                          <div class="upload-text">مەزمۇن رەسىمىنى چىقىرىڭ</div>
                        </el-upload>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getToken } from '@/utils/auth'
import { IMAGE_URL, BASE_URL } from '@/utils/urls'
import draggable from 'vuedraggable'

export default {
  name: 'ShopCreate',
  components: {
    draggable
  },
  data() {
    return {
      imageURL: IMAGE_URL,
      serverURL: BASE_URL,
      statusMap: {
        1: { text: '在售', type: 'success' },
        2: { text: '售罄', type: 'warning' },
        3: { text: '下架', type: 'info' }
      },
      shopForm: {
        title_cn: '',
        title_ug: '',
        cover_cn: '',
        cover_ug: '',
        price: 0,
        stock: 0,
        desc_cn: '',
        desc_ug: '',
        swipers_cn: [],
        swipers_ug: [],
        posters_cn: [],
        posters_ug: [],
        need_addr: true,
        status: 1,
        tag_color: '',
        tag_cn: '',
        tag_ug: '',
        label_cn: '',
        label_ug: '',
        feature_cn: '',
        feature_ug: '',
        category_id: ''
      },
      submitting: false,
      categoryList: []
    }
  },
  created() {
    this.fetchCategories()
  },
  methods: {
    async fetchCategories() {
      try {
        const res = await this.$http.get('shop-cates', {
          params: {
            page: 1,
            size: 100
          }
        })
        if (!res.success) return this.$message.error(res.message)
        this.categoryList = res.data
      } catch (err) {
        this.$message.error(err.response?.data?.message || '获取分类列表失败')
      }
    },
    goBack() {
      this.$router.push('/admin/shop')
    },

    getUploadUrl(imageType) {
      return `${this.serverURL}/api/v1/shop/images/${imageType}?prod_name=${this.shopForm.title_cn || 'temp'}`
    },

    getHeaders() {
      const token = getToken()
      return {
        'Authorization': `Bearer ${token}`
      }
    },

    getImageUrl(path) {
      console.log('lalalala', path)
      return path.startsWith('http') ? path : `${this.imageURL}${path}`
    },

    beforeUpload(file) {
      const isImage = /^image\/(jpeg|png|gif|jpg)$/.test(file.type)
      const isLt10M = file.size / 1024 / 1024 < 10

      if (!isImage) {
        this.$message.error('只能上传 JPG/PNG/GIF 格式的图片!')
        return false
      }
      if (!isLt10M) {
        this.$message.error('图片大小不能超过 10MB!')
        return false
      }
      return true
    },

    uploaded(response, type) {
      if (!response.data) {
        this.$message.error('上传失败')
        return
      }

      const imageUrl = response.data
      
      if (type === 'swipers_cn' || type === 'swipers_ug' || 
          type === 'posters_cn' || type === 'posters_ug') {
        if (this.shopForm[type].length >= (type.includes('swiper') ? 5 : 10)) {
          this.$message.warning(`最多只能上传${type.includes('swiper') ? 5 : 10}张${type.includes('swiper') ? '轮播图' : '详情图'}`)
          return
        }
        this.shopForm[type].push(imageUrl)
      } else {
        this.shopForm[type] = imageUrl
      }
      
      this.$message.success('上传成功')
    },

    uploadError(err) {
      this.$message.error(err.response?.data?.message || '图片上传失败')
    },

    async removeImage(type, index) {
      try {
        const confirmResult = await this.$confirm('确认删除该图片?', '提示', {
          type: 'warning'
        })

        if (confirmResult === 'confirm') {
          if (type === 'swipers_cn' || type === 'swipers_ug' || 
              type === 'posters_cn' || type === 'posters_ug') {
            this.shopForm[type].splice(index, 1)
          } else {
            this.shopForm[type] = ''
          }
          this.$message.success('删除成功')
        }
      } catch (err) {
        if (err !== 'cancel') {
          this.$message.error('删除失败')
        }
      }
    },

    async submitForm() {
      // 表单验证
      if (!this.shopForm.title_cn || !this.shopForm.title_ug) {
        this.$message.warning('标题不能为空')
        return
      }
      if (!this.shopForm.desc_cn || !this.shopForm.desc_ug) {
        this.$message.warning('描述不能为空')
        return
      }
      if (!this.shopForm.price) {
        this.$message.warning('价格不能为空')
        return
      }
      if (!this.shopForm.stock) {
        this.$message.warning('库存不能为空')
        return
      }
      if (this.shopForm.price == 0) {
        this.$message.warning('价格不能为0')
        return
      }
      if (!this.shopForm.need_addr) {
        this.$message.warning('地址判断不能为空')
        return
      }
      if (!this.shopForm.status) {
        this.$message.warning('商品状态不能为空')
        return
      }
      if (!this.shopForm.cover_cn || !this.shopForm.cover_ug) {
        this.$message.warning('封面图片不能为空')
        return
      }
      if (this.shopForm.swipers_cn.length === 0 || this.shopForm.swipers_ug.length === 0) {
        this.$message.warning('轮播图不能为空')
        return
      }
      if (this.shopForm.posters_cn.length === 0 || this.shopForm.posters_ug.length === 0) {
        this.$message.warning('详情图不能为空')
        return
      }
      if (this.shopForm.price < 0 || this.shopForm.stock < 0) {
        this.$message.warning('价格和库存不能为负数')
        return
      }
      if (!this.shopForm.category_id) {
        this.$message.warning('商品分类不能为空')
        return
      }

      this.submitting = true
      try {
        await this.$http.post('shop', this.shopForm)
        this.$message.success('创建成功')
        this.goBack()
      } catch (err) {
        this.$message.error(err.response?.data?.message || '创建失败')
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
.shop-create {
  min-height: 100vh;

  .content-grid {
    display: grid;
    grid-template-columns: minmax(0, 2fr) minmax(0, 1fr);
    gap: 20px;
    margin: 0 auto;

    @media screen and (max-width: 1200px) {
      grid-template-columns: 1fr;
      
      .right-column {
        order: 2;
      }
      
      .left-column {
        order: 1;
        transform: translateY(20px);
      }
    }
  }
}

// 顶部操作栏样式
.action-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  background: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
  margin-bottom: 20px;
  border-radius: 8px;
}

.el-card {
  &.title-card,
  &.info-card,
  &.tags-card,
  &.desc-card,
  &.category-card,
  &.images-card {
    margin-bottom: 20px;
    border-radius: 8px;

    .card-header {
      position: relative;
      padding: 8px 20px;
      border-radius: 8px;
      background: #fafafa;
      display: flex;
      align-items: center;
      justify-content: space-between;

      span {
        font-size: 14px;
        font-weight: 500;
        color: #1f2937;
        padding-left: 10px;
        position: relative;

        &::before {
          content: '';
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 2px;
          height: 12px;
          background: #1890ff;
          border-radius: 1px;
        }
      }
    }
  }
}

// 标题卡片样式
.title-card {
  .title-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 24px;
    padding: 20px;

    .title-cn, .title-ug {
      .title-label {
        font-size: 13px;
        color: #666;
        margin-bottom: 12px;
      }
    }

    .title-ug {
      direction: rtl;

      .title-label {
        text-align: right;
      }

      .el-input__inner {
        direction: rtl;
        text-align: right;
      }
    }
  }
}

// 基本信息卡片样式
.info-card {
  .info-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 24px;
    padding: 20px;

    .info-column {
      display: flex;
      flex-direction: column;
      gap: 20px;

      .info-item {
        background: #fafafa;
        padding: 12px 16px;
        border-radius: 8px;
        border: 1px solid #f0f0f0;

        .info-label {
          font-size: 13px;
          color: #666;
          margin-bottom: 8px;
        }
      }
    }

    .price-input {
      :deep(.el-input-number__decrease),
      :deep(.el-input-number__increase) {
        background-color: #fff;
        border-color: #dcdfe6;
      }

      :deep(.el-input__inner) {
        font-size: 16px;
        font-weight: 500;
        color: #ff4d4f;
      }
    }

    .stock-input {
      :deep(.el-input-number__decrease),
      :deep(.el-input-number__increase) {
        background-color: #fff;
        border-color: #dcdfe6;
      }

      :deep(.el-input__inner) {
        font-size: 16px;
        font-weight: 500;
      }
    }
  }
}

// 描述卡片样式
.desc-card {
  .desc-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 24px;
    padding: 20px;

    .desc-cn, .desc-ug {
      .desc-label {
        font-size: 13px;
        color: #666;
        margin-bottom: 12px;
      }
    }

    .desc-ug {
      direction: rtl;

      .desc-label {
        text-align: right;
      }

      .ug-input {
        :deep(.el-textarea__inner) {
          font-family: 'Alpsoft Jurnal', sans-serif;
          text-align: right;
          direction: rtl;
        }
      }
    }
  }
}

// 图片卡片样式
.images-card {
  .images-wrapper {
    padding: 20px;
  }

  .image-section {
    margin-bottom: 32px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .cover-grid,
  .carousel-grid,
  .poster-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 24px;
  }

  .label-cn {
    font-size: 13px;
    color: #666;
    margin-bottom: 12px;
    direction: ltr;
  }

  .label-ug {
    font-size: 13px;
    color: #666;
    margin-bottom: 12px;
    direction: rtl;
  }

  .image-container {
    position: relative;
    width: 100%;
    border-radius: 8px;
    overflow: hidden;

    :deep(.el-image) {
      width: 100%;
      height: 100%;
      display: block;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .image-actions {
      position: absolute;
      top: 8px;
      right: 8px;
      opacity: 0;
      transition: opacity 0.3s;
      z-index: 1;
    }

    &:hover .image-actions {
      opacity: 1;
    }
  }

  .image-list {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(110px, 1fr));
    gap: 8px;

    .image-item {
      position: relative;
      border-radius: 8px;
      overflow: hidden;
      background-color: #f8f8f8;

      :deep(.el-image) {
        width: 100%;
        height: 100%;
        display: block;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .image-actions {
        position: absolute;
        top: 8px;
        right: 8px;
        opacity: 0;
        transition: opacity 0.3s;
        z-index: 1;
      }

      &:hover .image-actions {
        opacity: 1;
      }
    }
  }
}

.cover-shape {
  aspect-ratio: 16/10;
}

.carousel-shape {
  aspect-ratio: 15/10;
}

.poster-shape {
  aspect-ratio: 8/16;
}

.upload-box {
  border-radius: 8px;
  overflow: hidden;
  background-color: #fafafa;
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: #f5f5f5;
  }

  .image-uploader {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .el-icon-plus {
    font-size: 20px;
    color: #8c939d;
    margin-bottom: 8px;
  }

  .upload-text {
    font-size: 12px;
    color: #666;
  }
}

.el-button {
  padding: 10px 20px;
  transition: all 0.2s ease;

  &.delete-button {
    padding: 7px !important;
  }
}

.el-input :deep(.el-input__inner) {
  font-family: inherit;
}

.el-textarea :deep(.el-textarea__inner) {
  font-family: inherit;
}

// 标签和特性卡片样式
.tags-card {
  .tags-grid {
    padding: 20px;

    .tags-row {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 24px;
      margin-bottom: 20px;

      &:first-child {
        grid-template-columns: repeat(3, 1fr);
      }

      &:last-child {
        margin-bottom: 0;
      }
    }

    .tags-item {
      background: #fafafa;
      padding: 12px 16px;
      border-radius: 8px;
      border: 1px solid #f0f0f0;

      .tags-label {
        font-size: 13px;
        color: #666;
        margin-bottom: 8px;
      }
    }
  }
}

// 分类卡片样式
.category-card {
  margin-bottom: 20px;
  border-radius: 8px;

  .card-header {
    position: relative;
    padding: 8px 20px;
    border-radius: 8px;
    background: #fafafa;
    display: flex;
    align-items: center;
    justify-content: space-between;

    span {
      font-size: 14px;
      font-weight: 500;
      color: #1f2937;
      padding-left: 10px;
      position: relative;

      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 2px;
        height: 12px;
        background: #1890ff;
        border-radius: 1px;
      }
    }
  }

  .category-content {
    padding: 16px;

    .category-item {
      background: #fafafa;
      padding: 12px 16px;
      border-radius: 8px;
      border: 1px solid #f0f0f0;

      .category-label {
        font-size: 13px;
        color: #666;
        margin: 6px 0 8px 0;
      }
    }
  }
}
</style> 